export default "/_next/static/images/carli-auran-ba47e2db6e32393ae3e3d3ed08247776.png";